import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { CrearUsuarioDialog } from './crear-usuario-dialog/crear-usuario-dialog.component';
import { BotonTipo } from '../../../components/boton/boton';

@Component({
  selector: 'app-crear-usuario',
  templateUrl: './crear-usuario.component.html',
  styleUrls: ['./crear-usuario.component.scss']
})
export class CrearUsuarioComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() tooltipDir: string = 'below';
  @Output() onCerrado = new EventEmitter();

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
  }

  openDialog(): void {
    let dialogCrear = this.dialog.open(CrearUsuarioDialog, {
      disableClose: true
    });

    dialogCrear.afterClosed().subscribe(resultado => {
      this.onCerrado.emit();
    });
  }
}